// @flow
import React, { useState, useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import ResidentialLogoSvg from './ResidentialLogoSvg';
import BusinessLogoSvg from './BusinessLogoSvg';
import ComviqLogoSvg from './ComviqLogoSvg';
import * as cssTele2 from './HeaderTele2.module.css';
import * as cssComviq from './HeaderComviq.module.css';
import { useSelector } from 'react-redux';
import { CustomerTypes } from 'Constants';
import { isBusinessCustomer, isComviqCustomer } from '../../helpers/customerTypeHelpers';

type Props = {
  inverted?: boolean,
  showLogo: boolean,
};

const Header = ({ inverted, showLogo }: Props) => {
  const [showLogotype, setShowLogotype] = useState(false);

  const customerType = useSelector((state) => state.app.customerType);
  const isBusiness = isBusinessCustomer(customerType);
  const isComviq = isComviqCustomer(customerType);
  const css = isComviq ? cssComviq : cssTele2;

  useEffect(() => {
    if (customerType) {
      setShowLogotype(!!showLogo || showLogo === undefined);
    }
  }, [customerType]);

  if (isBusiness === undefined || !showLogotype || !css)
    return <Container as="header" className={inverted ? cssTele2.invertedHeader : cssTele2.header} />;

  return (
    <>
      <header className={inverted ? css.invertedHeader : css.header}>
        {!customerType || customerType === CustomerTypes.INVALID_CUSTOMER_TYPE ? (
          <></>
        ) : isComviq ? (
          <ComviqLogoSvg inverted={inverted} />
        ) : isBusiness ? (
          <BusinessLogoSvg inverted={inverted} />
        ) : (
          <ResidentialLogoSvg inverted={inverted} />
        )}
      </header>
    </>
  );
};

export default React.memo(Header);
